import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Landing from "@/pages/Landing";
import Studio from "@/pages/Studio";
import Gallery from "@/pages/Gallery";
import Makers from "@/pages/Makers";
import ApplyMaker from "@/pages/ApplyMaker";
import PublicLook from "@/pages/PublicLook";
import Lookbooks from "@/pages/Lookbooks";
import LookbookEditor from "@/pages/LookbookEditor";
import PublicLookbook from "@/pages/PublicLookbook";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  // Detect OAuth callback via URL fragment SYNCHRONOUSLY during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  // Public look/lookbook pages render their own brand; hide global navbar there
  const hideNav = location.pathname.startsWith("/look/") || location.pathname.startsWith("/collection/");
  return (
    <>
      {!hideNav && <Navbar />}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/studio" element={<Studio />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/makers" element={<Makers />} />
        <Route path="/apply-maker" element={<ApplyMaker />} />
        <Route path="/lookbooks" element={<Lookbooks />} />
        <Route path="/lookbooks/:id" element={<LookbookEditor />} />
        <Route path="/collection/:token" element={<PublicLookbook />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/look/:token" element={<PublicLook />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: { background: "#0a0a0a", color: "#fafafa", border: "1px solid #262626", borderRadius: 0, fontFamily: "Outfit" },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
